import React from "react";
import Svg, { Image, Defs, ClipPath, Rect } from "react-native-svg";

// Head component
export const CropImage = ({
  image,
  clipId,
  x,
  y,
  width,
  height,
  scale,
  transform,
}) => (
  <Svg width="100%" height="100%">
    <Defs>
      <ClipPath id={clipId}>
        <Rect x={x} y={y} width={width} height={height} />
      </ClipPath>
    </Defs>
    <Image
      href={image}
      width="100%" // Make the image fill the container
      height="100%" // Make the image fill the container
      clipPath={`url(#${clipId})`} // Apply the clipping
      scale={scale}
      transform={transform}
    />
  </Svg>
);
